import { isAnalyticsDebug, shouldLoadAnalytics } from './config';

function ensureDataLayer() {
  if (typeof window === 'undefined') return null;
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}

/**
 * Safe dataLayer push. Never throws — analytics must not break the app.
 * @param {Record<string, unknown>} payload
 */
export function pushToDataLayer(payload) {
  if (!shouldLoadAnalytics()) {
    if (isAnalyticsDebug() && payload?.event) {
      // eslint-disable-next-line no-console
      console.debug('[Analytics]', payload.event, payload);
    }
    return;
  }

  try {
    const { event, ...params } = payload || {};
    if (event && typeof window.gtag === 'function') {
      window.gtag('event', event, params);
    } else {
      const layer = ensureDataLayer();
      if (!layer) return;
      layer.push(payload);
    }
    if (isAnalyticsDebug()) {
      // eslint-disable-next-line no-console
      console.debug('[Analytics]', payload.event || 'dataLayer', payload);
    }
  } catch (err) {
    if (isAnalyticsDebug()) {
      // eslint-disable-next-line no-console
      console.debug('[Analytics] push failed (ignored)', err);
    }
  }
}
